import assetPath from '/app/packages/lebenslauf/articles/src/assets/reihenfolge-bewerbung.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')